export default {
  // Web app section
  main: {
    name: 'main',
    icon: 'mdi-cog'
  },
  edit: {
    name: 'edit',
    icon: 'mdi-pencil'
  }
}
